import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Dropdown } from 'antd';
import { Icon as CroplerIcon, Button } from '@cropler/ui-kit';
import avatarUrl from '../../assets/images/avatar.png';

import styles from './styles.module.scss';
import stylesDropdownMenu from '../../styles/dropdownMenu.module.scss';
import { useLogout } from '../../hooks';

export const ProfileMenu = ({ t }) => {
  const { avatar } = useSelector((state) => state.auth);
  const logoutUser = useLogout();

  const onLogout = async () => {
    await logoutUser();
  };

  const items = [
    {
      key: '1',
      label: (
        <Link className={stylesDropdownMenu.dropdownMenuLink} to="/profile">
          <CroplerIcon name="settings" />
          <span>{t('nav.profileSettings')}</span>
        </Link>
      ),
    },
    {
      key: '2',
      label: (
        <Button className={stylesDropdownMenu.dropdownMenuLink} onClick={() => onLogout()}>
          <CroplerIcon name="exit" />
          <span>{t('nav.logOut')}</span>
        </Button>
      ),
    },
  ];

  return (
    <Dropdown menu={{ items }}>
      <div className={styles.profileMenu}>
        <div className={styles.profileMenuImage}>
          <img src={avatar || avatarUrl} alt="avatar" />
        </div>
        <div className={styles.profileMenuArrow}>
          <CroplerIcon name="down" />
        </div>
      </div>
    </Dropdown>
  );
};
